module.exports = __webpack_public_path__ + "static/media/ic-category-cam-on.f72d9ac2.svg";